module.exports = __webpack_public_path__ + "public/Icons/question_info.svg?e5004fdb";